var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Payment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17C21.5 18.1046 20.6046 19 19.5 19H4.5C3.39543 19 2.5 18.1046 2.5 17V9.5H21.5V17ZM19.5 5C20.6046 5 21.5 5.89543 21.5 7V8H2.5V7C2.5 5.89543 3.39543 5 4.5 5H19.5Z",
    fill: "#A4ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Payment);
export default __webpack_public_path__ + "static/media/24_Payment.3aa11a097c5c8a79426b993d64e93a62.svg";
export { ForwardRef as ReactComponent };